module.exports = __webpack_public_path__ + "assets/icon_order_management_white.52630abe.svg";